import React, { useState, useContext } from 'react';

import AuthContext from '../../../contexts/auth';
import LayoutContext from '../../../contexts/layout';

import { errorAlert } from '../../../components/Toast';

import FormCheckUser from './FormCheckUser';
import ConfirmPhone from './ConfirmPhone';
import FormRegister from './FormRegister';

function Recovery() {
  const {
    loading,
    recoveryPassword,
    validateCodeRecovery,
    saveNewPassword,
  } = useContext(AuthContext);
  const { primaryColor, logoDefault } = useContext(LayoutContext);
  const [confirm, setConfirm] = useState(false);
  const [cpf, setCpf] = useState(null);
  const [user, setUser] = useState(null);
  const [cellEnd, setCellEnd] = useState(null);

  // DTGD-1463: so o CPF; o SMS vai para o celular do cadastro
  const handleSubmitCheck = async data => {
    const cgc_cliente = data.cgc_cliente.replace(/[^0-9]+/g, '');

    if (cgc_cliente.length !== 11) {
      return errorAlert('CPF do Titular deve ser preenchido corretamente');
    }

    setCpf(cgc_cliente);

    const result = await recoveryPassword(cgc_cliente);

    if (result.ok) {
      setCellEnd(result.cellEnd);
      setConfirm(true);
    }
  };

  const handleResendCode = async () => {
    const result = await recoveryPassword(cpf);

    if (result.ok) setCellEnd(result.cellEnd);

    return result;
  };

  const handleSubmitConfirm = async code => {
    const result = await validateCodeRecovery(code, cpf, 'recovery');

    if (result.ok) {
      setUser(result.user);
      setConfirm(false);
    }
  };

  const handleSubmitRegister = async (cgc_cliente, password) => {
    saveNewPassword(cgc_cliente, password);
  };

  return (
    <div className="col-lg-7">
      <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
        <div className="w-100">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div>
                <div>
                  <a href="/" className="logo">
                    <img src={logoDefault} height="80" alt="logo" />
                  </a>
                </div>
                {confirm ? (
                  <ConfirmPhone
                    loading={loading}
                    cellEnd={cellEnd}
                    onChange={handleSubmitConfirm}
                    onResendCode={handleResendCode}
                    primaryColor={primaryColor}
                  />
                ) : user ? (
                  <FormRegister
                    loading={loading}
                    user={user}
                    validateCodeRecovery={validateCodeRecovery}
                    onChange={handleSubmitRegister}
                    primaryColor={primaryColor}
                  />
                ) : (
                  <FormCheckUser
                    loading={loading}
                    onChange={handleSubmitCheck}
                    primaryColor={primaryColor}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Recovery;
